import { CircleAlert, CircleUserRound, LockKeyhole, Timer, WifiOff } from "lucide-react";
import { Link } from "react-router";
import { Notice } from "./parts";
import type { SignInNotice } from "./useSignIn";

/** Sign in 03 / 04 / 05 / 06: one notice above the form, in the frames' words. */
export function SignInNoticeView({ notice }: { notice: SignInNotice | null }) {
  if (!notice) return null;
  switch (notice.kind) {
    case "mismatch":
      return (
        <Notice tone="danger" icon={CircleAlert}>
          That email and password do not match. Check both, or reset your password.
        </Notice>
      );
    case "rate":
      return (
        <Notice tone="attention" icon={Timer}>
          Too many tries. Wait {notice.wait}, or reset your password.
        </Notice>
      );
    case "offline":
      return (
        <Notice tone="attention" icon={WifiOff}>
          Creo cannot be reached. Check your connection; what you typed stays.
        </Notice>
      );
    case "google-none":
      return (
        <Notice tone="info" icon={CircleUserRound}>
          No Creo account uses {notice.email}. Use the address your invitation went to.
        </Notice>
      );
    case "locked":
      return <LockedNotice email={notice.email} />;
    case "google-failed":
      return (
        <Notice tone="attention" icon={CircleAlert}>
          Google did not sign you in. Try again, or use your password.
        </Notice>
      );
  }
}

/**
 * An account locked from the CMS (password security). Sign in, Google and the
 * session dialog all show it; the way out is a reset link by email.
 */
export function LockedNotice({ email }: { email?: string }) {
  const to = `/forgot-password${email ? `?email=${encodeURIComponent(email)}` : ""}`;
  return (
    <Notice tone="danger" icon={LockKeyhole}>
      Your account is locked to keep it safe: your password may have been exposed.{" "}
      <Link to={to} className="font-medium text-co-text underline underline-offset-2">
        Email me a reset link
      </Link>{" "}
      and choose a new password to get back in.
    </Notice>
  );
}
